import Mixpanel from 'mixpanel-browser'

import { injectReducer } from 'store/reducers.js'
import { authRoute } from 'helpers/routes'
import { injectExternalList, injectExternalReducer } from 'helpers/actions'
import moment from 'helpers/moment'

export const PricelistRoute = (store) => Object.assign({}, authRoute(store), {
  path: 'pricelist(/:date)',
  authentication: false,
  getComponent (nextState, cb) {
    require.ensure([], (require) => {
      const Container = require('./containers/PricelistContainer').default

      const actions = require('./modules/pricelist').actions
      const reducer = require('./modules/pricelist').default
      const date = moment(nextState.params.date, { castAsTimezone: true }).format()

      injectReducer(store, { key: 'pricelist', reducer })
      injectExternalList(store, 'options')
      injectExternalList(store, 'uoms')

      injectExternalReducer(store, 'auth')
      injectExternalReducer(store, 'staging') // for view cart button

      store.dispatch(actions.get(date))

      Mixpanel.track('Pricelist', {
        date: date
      })

      cb(null, Container)
    }, 'daily_products')
  }
})

let baseDailyProductsRoute = (store) => Object.assign({}, authRoute(store), {
  path: 'daily_products(/:date)',
  authentication: 'admin',
  getComponent (nextState, cb) {
    require.ensure([], (require) => {
      const Container = require('./containers/DailyProductsContainer').default

      const reducer = require('./modules/daily_product').default
      const date = moment(nextState.params.date, { castAsTimezone: true }).format()

      injectReducer(store, { key: 'daily_product', reducer })
      injectExternalList(store, 'pricelist', date)

      injectExternalList(store, 'products')
      injectExternalList(store, 'options')
      injectExternalList(store, 'uoms')

      injectExternalReducer(store, 'auth')

      cb(null, Container)
    }, 'daily_products')
  }
})

export const DailyProductsRoute = (store) => baseDailyProductsRoute(store)
export const NewDailyProductRoute = (store) => Object.assign({}, baseDailyProductsRoute(store), {
  path: 'daily_products(/:date)/new'
})

export const EditDailyProductRoute = (store) => Object.assign({}, authRoute(store), {
  path: 'daily_products/:id/edit',
  authentication: 'admin',
  getComponent (nextState, cb) {
    require.ensure([], (require) => {
      const Container = require('./containers/EditDailyProductContainer').default

      const actions = require('./modules/daily_product').actions
      const reducer = require('./modules/daily_product').default

      injectReducer(store, { key: 'daily_product', reducer })
      injectExternalList(store, 'products')
      injectExternalList(store, 'options')
      injectExternalList(store, 'uoms')

      injectExternalReducer(store, 'auth')

      store.dispatch(actions.get(nextState.params.id)).then(action => {
        const date = moment(action.payload && action.payload.date, { castAsTimezone: true }).format()
        injectExternalList(store, 'pricelist', date)
      })

      cb(null, Container)
    }, 'daily_products')
  }
})

export default function (store) {
  return [
    NewDailyProductRoute(store),
    EditDailyProductRoute(store),
    PricelistRoute(store),
    DailyProductsRoute(store)
  ]
}



// WEBPACK FOOTER //
// ./src/routes/DailyProducts/index.js